<h1>Reports</h1>

<section>
    <p><a href="/report-monthly-revenue">Revenue by Month</a>
    <p><a href="/report-enrolled">Enrolled Dealers</a>
    <p><a href="/report-unenrolled">Unenrolled Dealers</a>
    <p><a href="/report-tiers">Total Dealers by Tier</a>
</section>
